import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import {SingleValue} from 'react-select';
import InputTypeAhead from '../../../../common/components/ui/InputTypeAhead';
import {useInvoicesGridContext} from '../InvoicesGridContext';
import search from '../../../../common/assets/icons/search.svg';
import styles from './FieldCustomerID.module.scss';

type Option = {label: string, value:string};

const FieldCustomerID = () => {
  const intl = useIntl();
  const placeholderLabel = intl.formatMessage({id: 'invoices-col-customer', defaultMessage: 'Customer'});
  const [field, meta, helper] = useField({name: 'customerID'});
  const {loadOptions} = useInvoicesGridContext();

  const handleChange = (customer: SingleValue<Option>) => {
    helper.setValue(customer?.value || null);
  };

  const inputValue = field?.value
    ? {label: field.value, value: field.value}
    : {label: '', value: ''};

  return (
    <div className={styles.searchContainer}>
      <InputTypeAhead
        <Option, false>
        {...field}
        {...meta}
        id={field.name}
        placeholder={placeholderLabel}
        value={inputValue}
        loadOptions={loadOptions}
        onChange={handleChange}
      />
      <img
        src={search}
        alt="search"
        className={styles.searchIcon}
      />
    </div>
  );
};

export default FieldCustomerID;
